// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import CloseOutlinedSvg from "@ant-design/icons-svg/lib/asn/CloseOutlined";
import AntdIcon from "../components/AntdIcon";
const CloseOutlined = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: CloseOutlinedSvg
    });
if (process.env.NODE_ENV !== "production") {
    CloseOutlined.displayName = "CloseOutlined";
}
export default /*#__PURE__*/ React.forwardRef(CloseOutlined);
